import { InputSelectControl } from '@sequencehq/core-components'
import { useSelectedCurrency } from 'RevenueRecognition/view/utils/useSelectedCurrency'
import { Currency } from '@sequencehq/api'
import { useAvailableCurrencies } from 'RevenueRecognition/view/utils/useAvailableCurrencies'

export const RevRecDashboardCurrencyFilter = () => {
  const { currency, setCurrency } = useSelectedCurrency()
  const { availableCurrencies } = useAvailableCurrencies()

  if (!currency || !availableCurrencies) {
    return null
  }

  return (
    <InputSelectControl
      triggerStyle={{ width: '84px', height: '32px' }}
      data-testid="revrec.dashboard.currencySelect"
      options={
        availableCurrencies?.map(ac => ({
          label: ac,
          value: ac
        })) ?? []
      }
      initialValue={currency}
      onChange={newCurrency => setCurrency(newCurrency as Currency)}
    />
  )
}
